import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuth } from './useAuth'
import { mapDocument } from '@/mappers/document.mapper'

/**
 * The member's documents (`/me`) as `MemberDocument` view-models, mapped with
 * the active locale (the title is localized from the document kind). Read-only.
 * Must be called from component setup (needs i18n).
 */
export function useDocuments() {
  const { t } = useI18n()
  const { rawDocuments } = useAuth()

  const documents = computed(() => rawDocuments.value.map((raw) => mapDocument(raw, t)))

  return { documents }
}
